export default "__VITE_ASSET__DNvHelXZ__"